import { useEffect, useState } from "react";
import { overlayVerifiedCatalogue, snapshotPayload } from "../data/market";
import { fetchLiveMarket } from "../lib/marketClient";
import type { MarketPayload } from "../types";

const POLL_MS = 60_000;

export function useMarket(): { market: MarketPayload; loading: boolean } {
  const [market, setMarket] = useState<MarketPayload>(snapshotPayload);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    async function pull() {
      try {
        const bundled = snapshotPayload();
        const data = await fetchLiveMarket();
        if (!alive || !data?.products.length) return;
        const products = overlayVerifiedCatalogue(bundled.products, data.products);
        setMarket({
          ...data,
          products,
          brands: new Set(products.map((row) => row.lender)).size,
        });
      } catch {
        /* keep the verified snapshot */
      } finally {
        if (alive) setLoading(false);
      }
    }

    void pull();
    const id = window.setInterval(pull, POLL_MS);
    return () => {
      alive = false;
      window.clearInterval(id);
    };
  }, []);

  return { market, loading };
}
